import { Alert } from 'antd';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
    position: relative;
    width: 100%;
    z-index: 1;
    opacity: 0.8;
`;